export default __webpack_public_path__ + "static/MyM-keyart-animated-3c2bb7ccefd785ac78cc46c112d3eb55.mp4";